import { render, staticRenderFns } from "./UpdateProductBtn.vue?vue&type=template&id=54d4efa0&scoped=true&"
import script from "./UpdateProductBtn.vue?vue&type=script&lang=js&"
export * from "./UpdateProductBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4efa0",
  null
  
)

export default component.exports